import React, { useMemo } from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { ValuesList } from '../../../UI/ValuesList/ValuesList';

export const EstimateMeasurementDoors = () => {
    const { manualCalculations } = useSelector((state) => state.measurementsReducer);

    const { t } = useTranslation();

    const values = useMemo(() => {
        const doorValues = [
            {
                title: t('EstimateMeasurementDoors.doorValues.title.door_quantity'),
                type: 'door_quantity',
                value: manualCalculations.door_quantity,
                unit: t('MeasurementDoors.unit.quantity'),
            },
            {
                title: t('EstimateMeasurementDoors.doorValues.title.door_area'),
                type: 'door_area',
                value: manualCalculations.door_area,
                unit: t('MeasurementDoors.unit.slope_area'),
            },
            {
                title: t('EstimateMeasurementDoors.doorValues.title.door_perimeter'),
                type: 'door_perimeter',
                value: manualCalculations.door_perimeter,
                unit: t('MeasurementDoors.unit.slope_perimeter'),
            },
            {
                title: t('EstimateMeasurementDoors.doorValues.title.door_slope_area'),
                type: 'door_slope_area',
                value: manualCalculations.door_slope_area,
                unit: t('MeasurementDoors.unit.slope_area'),
            },
            {
                title: t('EstimateMeasurementDoors.doorValues.title.door_slope_perimeter'),
                type: 'door_slope_perimeter',
                value: manualCalculations.door_slope_perimeter,
                unit: t('MeasurementDoors.unit.perimeter'),
            },
        ];

        const hasValues = doorValues.some((doorValue) => parseInt(doorValue.value, 10) > 0);

        return hasValues ? doorValues : [];
    }, [
        manualCalculations.door_quantity,
        manualCalculations.door_area,
        manualCalculations.door_perimeter,
        manualCalculations.door_slope_area,
        manualCalculations.door_slope_perimeter,
    ]);

    return (
        <>
            {!!values.length && (
                <ValuesList
                    title={t('EstimateMeasurementDoors.return.ValuesList.title')}
                    values={values}
                />
            )}
        </>
    );
};
